export default "__VITE_ASSET__Cmw$t9z7__"